import { apiFetch } from '../api';

class RekognitionService {
  async detectFaces(imageData) {
    try {
      const res = await apiFetch('/api/detect-faces', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image: imageData })
      });
      const data = await res.json();
      if (!data.success) throw new Error('Failed to detect faces.');
      return { FaceDetails: data.faceDetails };
    } catch (error) {
      throw new Error('Failed to detect faces. Please check your backend and try again.');
  }
  }

  async compareFaces(sourceImage, targetImage, userId) {
    try {
      const res = await apiFetch('/api/verify-face', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, image: targetImage })
      });
      const data = await res.json();
      if (!data.success) throw new Error('Failed to compare faces.');
      return { FaceMatches: [{ Similarity: data.confidence }] };
    } catch (error) {
      throw new Error('Failed to compare faces. Please check your backend and try again.');
    }
  }

  async uploadSnapshot(userId, examId, imageData) {
    try {
      const res = await apiFetch('/api/upload-snapshot', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, examId, image: imageData })
      });
      const data = await res.json();
      if (!data.success || !data.url) throw new Error('Failed to upload snapshot.');
      return data.url;
    } catch (error) {
      throw new Error('Failed to upload snapshot. Please check your backend and try again.');
    }
  }
}

const rekognitionService = new RekognitionService();
export default rekognitionService; 